/* eslint-disable no-sequences */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import cn from 'classnames';

import { Usergroup, Table, Auth } from 'services/action';
import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  privileges: [],
  module: null,
};

const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['usergroup']);

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  const [{ name, privileges, module, isLoading }, setState] =
    React.useState(initialState);

  const $handleSubmit = async (c) => {
    let x = [];

    _.find(privileges, function (item) {
      if (item?.action !== 'tidak_ada') {
        x.push(item?.id);
      }
    });

    const payload = {
      name,
      privileges: x,
    };

    if (data) {
      const submit = await Dispatch(Usergroup.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('usergroup', StateTable));
      }
    } else {
      const submit = await Dispatch(Usergroup.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('usergroup', StateTable));
      }
    }
  };

  const $getAuth = async () => {
    const req = await Dispatch(Auth.$authorization());

    if (req?.message === 'success') {
      var odds = _.filter(req?.data, function (d) {
        if (
          d?.module === 'booking' ||
          d?.module === 'invoice' ||
          d?.module === 'report' ||
          d?.module === 'tenant' ||
          d?.module === 'recipient location' ||
          d?.module === 'sender location' ||
          d?.module === 'pickup location' ||
          d?.module === 'shipment' ||
          d?.module === 'order' ||
          d?.module === 'customer pricing'
        ) {
          return false;
        }

        if (d?.application === 'platform' || d?.application === 'tms') {
          return true;
        }
      });

      let x = _.groupBy(odds, 'module');
      let permit = [];

      for (let [key, value] of Object.entries(x)) {
        const empty = {
          id: `${key}-null`,
          action: 'tidak_ada',
          module: key,
        };

        const defaults = {
          name: key,
          action: 'tidak_ada',
          id: `${key}-null`,
        };

        permit.push(defaults);
        value?.push(empty);
      }

      setState((prevState) => ({
        ...prevState,
        module: x,
        privileges: permit,
      }));
    }
  };

  const $restoreModule = async (p) => {
    const req = await Dispatch(Auth.$authorization());
    let priviledge = await p?.map((d) => d);

    if (req?.message === 'success') {
      var odds = _.filter(req?.data, function (d) {
        if (
          d?.module === 'booking' ||
          d?.module === 'invoice' ||
          d?.module === 'report' ||
          d?.module === 'tenant' ||
          d?.module === 'recipient location' ||
          d?.module === 'sender location' ||
          d?.module === 'pickup location' ||
          d?.module === 'shipment' ||
          d?.module === 'order' ||
          d?.module === 'customer pricing'
        ) {
          return false;
        }

        if (d?.application === 'platform' || d?.application === 'tms') {
          return true;
        }
      });

      let x = _.groupBy(odds, 'module');
      let permit = [];

      for (let [key, value] of Object.entries(x)) {
        const empty = {
          id: `${key}-null`,
          action: 'tidak_ada',
          module: key,
        };
        value?.push(empty);
      }
      setState((prevState) => ({
        ...prevState,
        module: x,
      }));

      _.find(odds, function (item) {
        if (priviledge?.includes(item?.id)) {
          const restore = {
            name: item?.module,
            action: item?.action,
            id: item?.id,
          };
          permit?.push(restore);
        }
      });

      if (permit?.length > 0) {
        let x = permit?.map((d) => d?.name);
        _.find(odds, function (item) {
          if (!x?.includes(item?.module)) {
            const defaults = {
              name: item?.module,
              action: 'tidak_ada',
              id: `${item?.module}-null`,
            };
            permit?.push(defaults);
          }
        });
      }

      const y = _.uniq(permit, 'name');
      setState((prevState) => ({
        ...prevState,
        privileges: y,
      }));
    }
  };

  const handleChange = (val, key) => {
    const payload = {
      name: key,
      action: val?.action,
      id: val?.id,
    };

    if (key === 'delivery') {
      if (val?.action === 'manage') {
        let service = {};
        let location = {};
        let partner = {};
        let hub = {};

        const checkLocation = _.find(privileges, function (item) {
          return item?.name === 'location';
        });

        if (checkLocation?.action === 'manage') {
          location = checkLocation;
        } else {
          location = _.find(module['location'], function (item) {
            return item?.action === 'manage';
          });
        }

        const checkhub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkhub?.action === 'manage') {
          hub = checkhub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
          {
            name: 'location',
            action: location?.action,
            id: location?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only') {
        let service = {};
        let partner = {};
        let hub = {};

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkhub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkhub?.action === 'manage') {
          hub = checkhub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        _.each(result, function(i, key) {
          if (i?.name === 'dm') {
            result.splice(key, 1)
          }
        })

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'restore') {
        let service = {};
        let location = {};
        let partner = {};
        let hub = {};

        const checkLocation = _.find(privileges, function (item) {
          return item?.name === 'location';
        });

        if (checkLocation?.action === 'manage') {
          location = checkLocation;
        } else {
          location = _.find(module['location'], function (item) {
            return item?.action === 'manage';
          });
        }

        const checkhub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkhub?.action === 'manage') {
          hub = checkhub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        let dm = _.find(module['delivery'], function(item) {
          return item?.action === 'manage'
        })

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'dm',
            action: dm?.action,
            id: dm?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
          {
            name: 'location',
            action: location?.action,
            id: location?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));

        console.log('===============pikirin dah yak===================')

      } else if (val?.action === 'tidak_ada') {
        let delivery = {};

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        if (checkManifest?.action === 'manage') {
          delivery = _.find(module['delivery'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          delivery = val;
        }

        const payload = [
          {
            name: key,
            action: delivery?.action,
            id: delivery?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        _.each(result, function(i, key) {
          if (i?.name === 'dm') {
            result.splice(key, 1)
          }
        })

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'contract') {
      if (val?.action === 'manage') {
        let service = {};
        let location = {};
        let partner = {};
        let vehicle = {};

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkLocation = _.find(privileges, function (item) {
          return item?.name === 'location';
        });

        if (checkLocation?.action === 'manage') {
          location = checkLocation;
        } else {
          location = _.find(module['location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        vehicle = _.find(module['vehicle'], function (item) {
          return item?.action === 'read_only';
        });

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'dm',
            action: null,
            id: null,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'location',
            action: location?.action,
            id: location?.id,
          },
          {
            name: 'vehicle',
            action: vehicle?.action,
            id: vehicle?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only') {
        let service = {};
        let partner = {};
        let vehicle = {};

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        if (checkManifest?.action === 'manage') {
          vehicle = _.find(module['vehicle'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          vehicle = {
            name: 'vehicle',
            action: 'tidak_ada',
            id: 'vehicle-null',
          };
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'vehicle',
            action: vehicle?.action,
            id: vehicle?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'manifest') {
      if (val?.action === 'manage') {
        let partner = {};
        let driver = {};
        let hub = {};
        let service = {};
        let vehicle = {};
        let job = {};

        let delivery = {};
        let location = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        if (checkDelivery?.action !== 'tidak_ada') {
          delivery = checkDelivery;
        } else {
          delivery = _.find(module['delivery'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkLocation = _.find(privileges, function (item) {
          return item?.name === 'location';
        });

        if (checkLocation?.action === 'manage') {
          location = checkLocation;
        } else {
          location = _.find(module['location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkDriver = _.find(privileges, function (item) {
          return item?.name === 'driver';
        });

        if (checkDriver?.action === 'manage') {
          driver = checkDriver;
        } else {
          driver = _.find(module['driver'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkHub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkHub?.action === 'manage') {
          hub = checkHub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        vehicle = _.find(module['vehicle'], function (item) {
          return item?.action === 'read_only';
        });

        job = _.find(module['job'], function (item) {
          return item?.action === 'read_only';
        });

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'driver',
            action: driver?.action,
            id: driver?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
          {
            name: 'delivery',
            action: delivery?.action,
            id: delivery?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
          {
            name: 'location',
            action: location?.action,
            id: location?.id,
          },
          {
            name: 'vehicle',
            action: vehicle?.action,
            id: vehicle?.id,
          },
          {
            name: 'job',
            action: job?.action,
            id: job?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only') {
        let hub = {};
        let vehicle = {};

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        if (checkContract?.action === 'manage') {
          vehicle = _.find(module['vehicle'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          vehicle = {
            name: 'vehicle',
            action: 'tidak_ada',
            id: 'vehicle-null',
          };
        }

        const checkHub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkHub?.action === 'manage') {
          hub = checkHub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
          {
            name: 'vehicle',
            action: vehicle?.action,
            id: vehicle?.id,
          },
          {
            name: 'job',
            action: 'tidak_ada',
            id: 'job-null',
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let vehicle = {};

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        if (checkContract?.action === 'manage') {
          vehicle = _.find(module['vehicle'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          vehicle = {
            name: 'vehicle',
            action: 'tidak_ada',
            id: 'vehicle-null',
          };
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'vehicle',
            action: vehicle?.action,
            id: vehicle?.id,
          },
          {
            name: 'job',
            action: 'tidak_ada',
            id: 'job-null',
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'service') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let service = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        const checkPricing = _.find(privileges, function (item) {
          return item?.name === 'pricing';
        });

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        if (
          checkContract?.action !== 'tidak_ada' ||
          checkDelivery?.action !== 'tidak_ada' ||
          checkPricing?.action !== 'tidak_ada' ||
          checkManifest?.action === 'manage'
        ) {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          service = val;
        }

        const payload = [
          {
            name: key,
            action: service?.action,
            id: service?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'pricing') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        let service = {};

        const checkService = _.find(privileges, function (item) {
          return item?.name === 'service';
        });

        if (checkService?.action === 'manage') {
          service = checkService;
        } else {
          service = _.find(module['service'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'service',
            action: service?.action,
            id: service?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'hub location') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let hub = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        const checkUser = _.find(privileges, function (item) {
          return item?.name === 'user';
        });

        if (
          checkDelivery?.action === 'manage' ||
          checkDelivery?.action === 'read_only' ||
          checkUser?.action === 'manage' ||
          checkManifest?.action === 'manage' ||
          checkManifest?.action === 'read_only'
        ) {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          hub = val;
        }

        const payload = [
          {
            name: key,
            action: hub?.action,
            id: hub?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'driver') {
      if (val?.action === 'manage') {
        let partner = {};

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let driver = {};

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        if (checkManifest?.action === 'manage') {
          driver = _.find(module['driver'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          driver = val;
        }

        const payload = [
          {
            name: key,
            action: driver?.action,
            id: driver?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'user') {
      if (val?.action === 'manage') {
        let usergroup = {};
        let hub = {};

        const checkUsergroup = _.find(privileges, function (item) {
          return item?.name === 'usergroup';
        });

        if (checkUsergroup?.action === 'manage') {
          usergroup = checkUsergroup;
        } else {
          usergroup = _.find(module['usergroup'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkHub = _.find(privileges, function (item) {
          return item?.name === 'hub location';
        });

        if (checkHub?.action === 'manage') {
          hub = checkHub;
        } else {
          hub = _.find(module['hub location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'usergroup',
            action: usergroup?.action,
            id: usergroup?.id,
          },
          {
            name: 'hub location',
            action: hub?.action,
            id: hub?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only' || val?.action === 'tidak_ada') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'usergroup') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let usergroup = {};

        const checkUser = _.find(privileges, function (item) {
          return item?.name === 'user';
        });

        if (checkUser?.action === 'manage') {
          usergroup = _.find(module['usergroup'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          usergroup = val;
        }

        const payload = [
          {
            name: key,
            action: usergroup?.action,
            id: usergroup?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'partner') {
      if (val?.action === 'manage') {
        let user = {};
        let location = {};

        const checkUser = _.find(privileges, function (item) {
          return item?.name === 'user';
        });

        if (checkUser?.action === 'manage') {
          user = checkUser;
        } else {
          user = _.find(module['user'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const checkLocation = _.find(privileges, function (item) {
          return item?.name === 'location';
        });

        if (checkLocation?.action === 'manage') {
          location = checkLocation;
        } else {
          location = _.find(module['location'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
          {
            name: 'user',
            action: user?.action,
            id: user?.id,
          },
          {
            name: 'location',
            action: location?.action,
            id: location?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let partner = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        const checkCustomerPricing = _.find(privileges, function (item) {
          return item?.name === 'customer pricing';
        });

        if (
          (checkDelivery && checkDelivery?.action !== 'tidak_ada') ||
          (checkContract && checkContract?.action !== 'tidak_ada') ||
          (checkCustomerPricing &&
            checkCustomerPricing?.action !== 'tidak_ada')
        ) {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          partner = val;
        }

        const payload = [
          {
            name: key,
            action: partner?.action,
            id: partner?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'location') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        let partner = {};
        let location = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        if (checkDelivery && checkDelivery?.action === 'manage') {
          location = _.find(module['location'], function (item) {
            return item?.action === 'manage';
          });
        } else {
          location = val;
        }

        const checkPartner = _.find(privileges, function (item) {
          return item?.name === 'partner';
        });

        if (checkPartner?.action === 'manage') {
          partner = checkPartner;
        } else {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        }

        const payload = [
          {
            name: key,
            action: location?.action,
            id: location?.id,
          },
          {
            name: 'partner',
            action: partner?.action,
            id: partner?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let location = {};

        const checkDelivery = _.find(privileges, function (item) {
          return item?.name === 'delivery';
        });

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        if (
          (checkDelivery && checkDelivery?.action === 'read_only') ||
          (checkContract && checkContract?.action === 'manage')
        ) {
          location = _.find(module['location'], function (item) {
            return item?.action === 'read_only';
          });
        } else if (checkDelivery && checkDelivery?.action === 'manage') {
          location = _.find(module['location'], function (item) {
            return item?.action === 'manage';
          });
        } else {
          location = val;
        }

        const payload = [
          {
            name: key,
            action: location?.action,
            id: location?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else if (key === 'partner') {
      if (val?.action === 'manage' || val?.action === 'read_only') {
        const payload = [
          {
            name: key,
            action: val?.action,
            id: val?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      } else if (val?.action === 'tidak_ada') {
        let partner = {};

        const checkDriver = _.find(privileges, function (item) {
          return item?.name === 'driver';
        });

        const checkManifest = _.find(privileges, function (item) {
          return item?.name === 'manifest';
        });

        const checkContract = _.find(privileges, function (item) {
          return item?.name === 'contract';
        });

        if (
          (checkManifest && checkManifest?.action === 'manage') ||
          (checkDriver && checkDriver?.action === 'manage') ||
          (checkContract && checkContract?.action !== 'tidak_ada')
        ) {
          partner = _.find(module['partner'], function (item) {
            return item?.action === 'read_only';
          });
        } else {
          partner = val;
        }

        const payload = [
          {
            name: key,
            action: partner?.action,
            id: partner?.id,
          },
        ];

        const result = Object.values(
          []
            .concat(privileges, payload)
            .reduce(
              (r, c) => ((r[c.name] = Object.assign(r[c.name] || {}, c)), r),
              {}
            )
        );

        setState((prevState) => ({ ...prevState, privileges: result }));
      }
    } else {
      const index = privileges.findIndex((item) => item?.name === key);
      const newArray = [...privileges];

      if (index !== -1) {
        newArray.splice(index, 1);
        newArray.push(payload);
      } else {
        newArray.push(payload);
      }
      setState((prevState) => ({ ...prevState, privileges: newArray }));
    }
  };

  React.useEffect(() => {
    if (data) {
      $restoreModule(data?.privileges);
      setState((prevState) => ({
        ...prevState,
        name: data?.name,
      }));
    } else {
      $getAuth();
    }
  }, [data]);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  const Checkbox = ({ onChange, label, value }) => {
    const [index, setIndex] = React.useState();

    const checked = async () => {
      const x = _.findWhere(privileges, { id: value?.id });
      setIndex(x);
    };

    const handleChange = async () => {
      onChange();
    };

    React.useLayoutEffect(() => {
      checked();
    });

    return (
      <Form.Checkbox
        value={value?.id === index?.id}
        iconSize={18}
        onChange={handleChange}
        label={<span className="text-capitalize">{label}</span>}
      />
    );
  };

  if (isLoading) {
    return (
      <div>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <Modal.Body>
        <Form.Input
          required
          label="Nama Usergroup"
          type="text"
          value={name}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, name: e?.target?.value }))
          }
          error={StateForm?.errors?.name}
        />

        <div
          className={cn(
            StateForm?.errors?.privileges ? 'border-danger border' : '',
            'mx-1'
          )}
        >
          <div className="row py-3 bg-light m-0 fw-semibold border-top border-bottom">
            <div className="col-6 col-md-5">Modul</div>
            <div className="col-6 col-md-7">Hak Akses</div>
          </div>
          {module &&
            Object.entries(module)
              ?.sort()
              .map(([key, value]) =>
                key !== 'booking' && key !== 'vehicle' && key !== 'job' ? (
                  <div key={key}>
                    <div className="row py-2 m-0 border-bottom align-items-center ">
                      <div className="col-5 col-md-5 ">
                        <div className="text-capitalize my-1">
                          {key?.replace('location', 'lokasi')?.replace('partner', 'Customer & Vendor')}
                        </div>
                      </div>
                      <div className="col-7 col-md-7">
                        <div className="row align-items-center">
                          {value
                            ?.sort(function (a, b) {
                              if (a.action < b.action) return 1;
                              if (a.action > b.action) return -1;
                              return 0;
                            })
                            .map((el, k) => (
                              <div className="col-4" key={k}>
                                <Checkbox
                                  value={el}
                                  name={key}
                                  onChange={() => handleChange(el, key)}
                                  label={el?.action?.replace('_', ' ')}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null
              )}
        </div>
        {StateForm?.errors?.privileges ? (
          <div className="d-block invalid-feedback">
            {StateForm?.errors?.privileges}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className="btn btn-light w-100"
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};

export default FormInput;
